module.exports = __webpack_public_path__ + "static/image-strip-recording-e2c9f6b65380fc2bb2e89f913391f4ec.jpg";